import React, { Component } from 'react';
import { TextField } from 'rmwc/TextField';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Button } from 'rmwc/Button';
import { FormField} from 'rmwc/FormField';
import { Card } from 'rmwc/Card';
import { Grid, GridCell } from 'rmwc/Grid';
import { Radio } from 'rmwc/Radio';
import { connect } from 'react-redux';
import SerializeForm from 'form-serialize';
import * as api from '../api/api';
import GooglePlacesAutoComplete from './GooglePlacesAutoComplete';
import StatusMessage from '../util/StatusMessage';
import PlacesAutoComplete from 'react-places-autocomplete';
import GoogleTagManager from '../util/GoogleTagManager';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'

class TQRegistrationUpdate extends Component {

	constructor(props){
		super(props)
		this.state = {
			errorMsg: '',
			currentDate: '',
      cert_part_id: '',
			data:{
				'firstName': '',
				'lastName': '',
				'email': '',
				'phone': '',
				'countries': [],
				'countryId': '',
				'dob': '',
				'examDateOption': '',
        'examDate': '',
				'teachingAssociations': [],
				'teachingAssociationId': '',
        'teachingAssociationName': '',
        'workingOrganization': '',
				'tqTestTracks': [],
				'tqTestTrackId': '',
				'trackEligibility': '',
				'trackDetailMessage': '',
				'paymentModeId': '',
				'paymentModes': [],
				'referralCode': '',
        'tqRegId': '',
        'tqType': [],
        'tqTypeId' : '',
				'trackAmount': 0,
        'discountValue': 0,
        'registrationFee': 0.0,
        'initialFee': '',
        'usDollarAmount': 0.0,
        'discountedDollarValue': 0.0,
        'registrationFeeInDollar': 0.0,
        'addOnOptions': [],
        'selectedAddonOption': '',
        'isAddOnAvailableForParentTrack': '',
        'trackFeeWithoutAddon': '',
        'trackFeeInDollarWithoutAddon': '',
        'trackFeeWithAddon':'',
        'trackFeeInDollarWithAddon':'',
        'initialFeeWithAddOn': '',
        'initialTqTestTrack': '',
        'initialSelectedAddonOption': '',
        'initalAddonAvailableforParentTrack': '',
        'tqTestDates': [],
        'tqTestDateId': '',
        'timeSlots': [],
        'timeSlot': ''

			},
			componentState:{
        firstNamedisabled: false,
        lastNamedisabled: false,
        countryDisabled: false,
        phoneDisabled: false,
        tqTrackDisabled: false,
        dobDisabled: false,
      },
      saveState:{
      	saveDisabled: false,
        reDirLinkDisabled: true,
      },
      formErrors:{
      	'firstNameError': '',
      	'lastNameError': '',
      	'emailError': '',
      	'emailFormatError': '',
      	'phoneError': '',
      	'dobError': '',
      	'countryIdError': '',
      	'teachingAssociationIdError': '',
      	'workingOrganizationError': '',
      	'examDateError': '',
      	'examDateOptionError': '',
      	'tqTestTrackError': '',
      	'paymentModeError': '',
      	'referralCodeError': '',
        'trackEligibilityError': '',
        'tqTypeError': '',
        'timeSlotError': '',
      },
		}
	}

	componentDidMount(){

    //Check for google analytics

    let data = Object.assign({}, this.state.data)
    let componentState = Object.assign({}, this.state.componentState)
    let errorObj = Object.assign({}, this.state.formErrors)
    let saveState = Object.assign({}, this.state.saveState)
    let countryIdToPass
    let trackIdToPass
    let certificateName
    let testDateId
    let  currentTime = new Date()
    let m = currentTime.getMonth() + 1
    let d = currentTime.getDate()
    let y = currentTime.getFullYear()
    let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
    let cert_part_id = this.props.match.params.cert_part_id
    let url = 'fetch/tq/registration/' + this.props.match.params.cert_part_id
    let tqAddonOptionURL = `fetch/registration/options/tq`
    api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if(result.status === 'success'){
        data.firstName = result.data.first_name
        data.lastName = result.data.last_name
        data.email = result.data.email
        data.phone = result.data.phone
        data.dob = result.data.dob
        data.tqRegId = result.data.tq_certification_id
        data.teachingAssociationId = result.data.teaching_association_id
        data.teachingAssociationName = result.data.teaching_association_name
        data.workingOrganization = result.data.working_organization
        data.tqTestTrackId = result.data.tq_test_track_id
        certificateName = result.data.source_of_reg
        if(data.tqTestTrackId !== '' || data.tqTestTrackId !== null || data.tqTestTrackId !== undefined){
            trackIdToPass = data.tqTestTrackId
        }
        data.initialTqTestTrack = data.tqTestTrackId
        data.isAddOnAvailableForParentTrack = result.data.is_add_on_association_available
        if(data.isAddOnAvailableForParentTrack){
          data.selectedAddonOption = result.data.is_add_on_available
          data.initialSelectedAddonOption = data.selectedAddonOption
          data.initalAddonAvailableforParentTrack = data.isAddOnAvailableForParentTrack
        }
        data.examDateOption = result.data.exam_date_option
        data.examDate = result.data.selected_exam_date
        if(new Date (data.examDate) < currentDate){
          data.examDate = ''
          data.examDateOption = ''
        }
        else {
          data.timeSlot = result.data.time_slot
        }
        data.paymentModeId = result.data.payment_mode_id
        data.countryId = result.data.country_id
        if(data.countryId !== '' || data.countryId !== null || data.countryId !== undefined){
          countryIdToPass = data.countryId
          componentState.countryDisabled = true
        }
        else {
          countryIdToPass = 0
        }
        if(data.firstName !== ''){
          componentState.firstNamedisabled = true
        }
        if(data.lastName !== ''){
          componentState.lastNamedisabled = true
        }
        if(data.dob){
          componentState.dobDisabled = true
        } 
        //if(data.phone !== '' || data.phone !== null || data.phone !== undefined){
          //componentState.phoneDisabled = true
        //}
      }
      else if (result.status === 'error'){
        saveState.saveDisabled = true
        this.setState({ errorMsg: result.message, saveState: saveState })
      }
        return api.getCountryBasedPaymentModes(this.props.user.accessToken, countryIdToPass)  
      }).then((result) => {
        data.paymentModes = result.data
        return api.getCountries(this.props.user.accessToken)
      }).then((result) => {
        data.countries = result
        return api.getTQTestTracks(this.props.user.accessToken, certificateName.toUpperCase())
      }).then((result) => {
        data.tqTestTracks = result
         if(!data.tqTestTracks.some(track => track.id === trackIdToPass)){
            data.tqTestTrackId = ''
            data.selectedAddonOption = ''
            data.examDate = ''
          }
        //General fee is disabled and track based fee is enabled.
        //return api.getFeeByCertificationType('TQ')
      //}).then((result) => {
      //  data.trackAmount = result.amount
      //  data.registrationFee = result.amount
      //  data.usDollarAmount = result.dollar_amount
      //  data.registrationFeeInDollar = result.dollar_amount
        return api.getTeachingAssociations(this.props.user.accessToken)
      }).then((result) => {
        data.teachingAssociations = result
        return api.getTqTypes(this.props.user.accessToken)
      }).then((result) => {
        data.tqType = result.data
        data.tqTypeId = result.data[0].id
        return api.getResponse(this.props.user.accessToken, tqAddonOptionURL)
      }).then((result) =>{
        data.addOnOptions = result.data
        return api.getResponse(this.props.user.accessToken, `/fetch/tq/track/fee/${trackIdToPass}`)
      }).then((result) =>{
        if(result.status === 'success'){
          data.trackAmount = result.data.amount
          data.registrationFee = result.data.amount
          data.usDollarAmount = result.data.dollar_amount
          data.registrationFeeInDollar = result.data.dollar_amount
        // incase ofaddon should be separtely stored for display purpose
          data.trackFeeWithoutAddon = result.data.amount
          data.trackFeeInDollarWithoutAddon = result.data.dollar_amount
          data.trackFeeWithAddon = result.data.add_on_amount
          data.trackFeeInDollarWithAddon = result.data.add_on_dollar_amount
          data.initialFee = result.data.inital_fee
          data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
        // if the user has opted for online option initally and if he is trying to update
          if(data.selectedAddonOption){
            data.trackAmount = data.trackFeeWithAddon
            data.registrationFee = data.trackFeeWithAddon
            data.usDollarAmount = data.trackFeeInDollarWithAddon
            data.registrationFeeInDollar = data.trackFeeInDollarWithAddon
          }
        }
        if(trackIdToPass){
          return api.getResponse(this.props.user.accessToken, `fetch/date/time/slot?type=exam_date&tq_test_track_id=${trackIdToPass}`)
          .then((result) => {
            if(result.status === 'error'){
              saveState.saveDisabled = true
              this.setState({data: data, componentState: componentState, currentDate: currentDate, cert_part_id: cert_part_id, errorMsg: result.message, saveState: saveState})
              return
            }
            data.tqTestDates = result.data
            if(data.examDate && data.tqTestDates.length > 0){
              testDateId = this.searchDate(data.examDate, data.tqTestDates)
              if(testDateId){
                return api.getResponse(this.props.user.accessToken, 
                  `fetch/date/time/slot?type=time_slot&tq_test_track_id=${trackIdToPass}&test_date_id=${testDateId}`)
                  .then((result) =>{
                  if(result.status === 'success'){  
                    data.timeSlots = result.data
                  }
                  this.setState({data: data, componentState: componentState, currentDate: currentDate, cert_part_id: cert_part_id})
                  return
                })
              }
              else {
                data.examDate = ''
                data.timeSlots = ''
                data.timeSlot = ''
              }
              this.setState({data: data, componentState: componentState, currentDate: currentDate, cert_part_id: cert_part_id})
              return
            }
            this.setState({data: data, componentState: componentState, currentDate: currentDate, cert_part_id: cert_part_id})
            return
          })
        }
        this.setState({data: data, componentState: componentState, currentDate: currentDate, cert_part_id: cert_part_id})
      })
	}

  onInputChange = (evt) => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data: data});
  }

  handleCountriesChange = (evt) => {
    const data = Object.assign({}, this.state.data);
    data.countryId = evt.target.value
    if(data.countryId !=='' || data.countryId !== null || data.countryId !== undefined){
      api.getCountryBasedPaymentModes(this.props.user.accessToken, data.countryId)
      .then((result) => {
        data.paymentModes = result.data
        this.setState({data: data})
      })
    }
  }

  handleTeachingAssociationSelection = (evt) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization=''
    if(evt.target.value){
      let selectedOption = evt.target.value
      var index = evt.target.selectedIndex;
      var optionElement = evt.target.childNodes[index]
      data.teachingAssociationId = selectedOption
      data.teachingAssociationName = optionElement.getAttribute('data-name')
    }
    else{
      data.teachingAssociationId = ''
      data.teachingAssociationName = ''
      
    }
    this.setState({data: data})
  }

  handleSchoolChange =(value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleSchoolSelect = (value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleTestTrackChange = (evt) => {
    this.setState({errorMsg: ''})
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({}, this.state.formErrors)
    let saveState = Object.assign({}, this.state.saveState)
    data.tqTestTrackId = evt.target.value
    if(evt.target.value){
      //on change of track the applied discount should be cleared
      data.discountValue = 0
      data.registrationFee = data.trackAmount
      data.registrationFeeInDollar = data.usDollarAmount
      if(data.referralCode !== ''){
        data.referralCode = ''
        errorObj.referralCodeError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
      }
      let url = `tq/check/track/eligibility/${data.tqTestTrackId}`
      let get_track_fee_url = `/fetch/tq/track/fee/${data.tqTestTrackId}`
      let getDatesUrl = `fetch/date/time/slot?type=exam_date&tq_test_track_id=${data.tqTestTrackId}`
      api.getResponse(this.props.user.accessToken, url)
      .then((result) =>{
        if(result.status === 'success'){
          data.trackEligibility = result.data.eligibility
          data.trackDetailMessage = result.data.track_detail
          data.isAddOnAvailableForParentTrack = result.data.is_add_on_available
          //reset add on selection
          data.selectedAddonOption = ''
        }
        else if (result.status === 'error'){
          errorObj.trackEligibilityError = result.message
        }

        if(data.trackEligibility === 'not_eligible' && (data.tqTestTrackId != data.initialTqTestTrack)){
          data.referralCode = ''
          errorObj.referralCodeError = ''
          saveState.saveDisabled = true
        }
        else{
          if(data.tqTestTrackId == data.initialTqTestTrack){
              data.isAddOnAvailableForParentTrack = data.initalAddonAvailableforParentTrack
              data.selectedAddonOption = data.initialSelectedAddonOption
            }
          saveState.saveDisabled = false
        }
        return api.getResponse(this.props.user.accessToken, get_track_fee_url)
        }).then((result) =>{
          if(result.status === 'success'){
            data.trackAmount = result.data.amount
            data.registrationFee = result.data.amount
            data.usDollarAmount = result.data.dollar_amount
            data.registrationFeeInDollar = result.data.dollar_amount

            // incase of addons addon should be separtely stored for display purpose
            data.trackFeeWithoutAddon = result.data.amount
            data.trackFeeInDollarWithoutAddon = result.data.dollar_amount
            data.trackFeeWithAddon = result.data.add_on_amount
            data.trackFeeInDollarWithAddon = result.data.add_on_dollar_amount
            data.initialFee = result.data.inital_fee
            data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
          }
        return api.getResponse(this.props.user.accessToken, getDatesUrl)
        }).then((result) => {

        if(result.status === 'success'){
          data.tqTestDates = result.data
          data.examDate = ''
          data.timeSlots = []
          data.timeSlot = ''
        }
        else if(result.status === 'error'){
          saveState.saveDisabled = true
          data.tqTestDates = []
          data.timeSlots = []
          data.timeSlot = ''
          this.setState({errorMsg: result.message, data: data, saveState: saveState})
        }
        this.setState({data: data, formErrors: errorObj, saveState: saveState})
      })
    }
  }

  handlePaymentModeChange = (evt) => {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = evt.target.value
    this.setState({data: data})
  }

  handleDiscountApply = (evt) =>{
    evt.preventDefault()
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({}, this.state.formErrors)
    errorObj.referralCodeError = ''
    
    api.getTQDiscountPerTrack('',4, this.state.data.referralCode, data.trackAmount, data.tqTestTrackId, data.selectedAddonOption)
      .then((result) => {
        if(result.status === 'success'){
          data.discountValue =  Number(result.discount)
          data.discountedDollarValue = result.discountedDollarAmount
          data.registrationFee = data.trackAmount - data.discountValue
          data.registrationFeeInDollar = data.usDollarAmount - data.discountedDollarValue
          data.registrationFeeInDollar = data.registrationFeeInDollar.toFixed(2)
          errorObj.referralCodeError = result.message
        }
        else if(result.status === 'error'){
          errorObj.referralCodeError = result.message
          data.discountValue = 0
          data.registrationFee = data.trackAmount
          data.registrationFeeInDollar = data.usDollarAmount
        }
        else{
          data.discountValue = 0
          data.registrationFee = data.trackAmount
          data.registrationFeeInDollar = data.usDollarAmount
        }
        this.setState({data: data, formErrors: errorObj})
    })
  }
    handletqTypeChange = (event) => {
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      let data = Object.assign({}, this.state.data)
      data.tqTypeId = event.target.value
      data.tqTypeName = optionElement.getAttribute('data-name')
      this.setState({data: data})
    }

    searchDate(nameKey, testDates){
      for (var i=0; i < testDates.length; i++) {
          if (testDates[i].exam_date === nameKey) {
            return testDates[i].test_date_id;
        }
      }
    }

    handleTQTimeSlotChange = (event) => {
      let data = Object.assign({}, this.state.data)
      data.timeSlot = event.target.value
      this.setState({data: data})
    }

    onAddonOptionChange = (event) => {

      let data = Object.assign({}, this.state.data)
      let errorObj = Object.assign({},this.state.formErrors)
      let valuetoSet =  parseInt(event.target.value)
      //Clear discount on change of Online selection
      data.discountValue = 0
      //Set the flag for ui and change the fee based on selection
      if(data.referralCode !== ''){
        data.referralCode = ''
        errorObj.referralCodeError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
      }
      if(this.state.data.selectedAddonOption !== ''){
        data[event.target.name] = ''
        data.registrationFee = data.trackFeeWithoutAddon
        data.trackAmount = data.trackFeeWithoutAddon
        data.usDollarAmount = data.trackFeeInDollarWithoutAddon
        data.registrationFeeInDollar = data.trackFeeInDollarWithoutAddon
      }
      else{
        data[event.target.name] = valuetoSet
        data.registrationFee = data.trackFeeWithAddon
        data.trackAmount = data.trackFeeWithAddon
        data.usDollarAmount = data.trackFeeInDollarWithAddon
        data.registrationFeeInDollar = data.trackFeeInDollarWithAddon
      }
      
      //Reset Discount
      data.discountValue = 0
      this.setState({data: data, formErrors: errorObj})
    }

    handleTQTestDateChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    let saveState = Object.assign({}, this.state.saveState)
    data.examDate = event.target.value
    let testDateId = this.searchDate(data.examDate, data.tqTestDates)
    let slotUrl = `fetch/date/time/slot?type=time_slot&tq_test_track_id=${data.tqTestTrackId}&test_date_id=${testDateId}`
    api.getResponse(this.props.user.accessToken, slotUrl)
    .then((result) => {
      if(result.status === 'success'){
        data.timeSlots = result.data
        data.timeSlot = ''
      }
      else if(result.status === 'error'){
        data.timeSlots = []
        data.timeSlot = ''
        saveState.saveDisabled = true
        this.setState({errorMsg: result.message, data: data, saveState: saveState})
      }

      this.setState({data: data})
    }).catch((error) => {
      this.setState({errorMsg: `Exception ${error.stack}`})
    })
  }

    validateForm(){

      let error = true
      let errorObj = Object.assign({}, this.state.formErrors)
      let data = Object.assign({}, this.state.data)
      let componentState = Object.assign({}, this.state.componentState)
      let saveState = Object.assign({}, this.state.saveState)
      let currentDate = this.state.currentDate
      errorObj.firstNameError =  ''
      errorObj.lastNameError =  ''
      errorObj.emailError =  ''
      errorObj.emailFormatError =  ''
      errorObj.phoneError =  ''
      errorObj.dobError =  ''
      errorObj.countryIdError =  ''
      errorObj.teachingAssociationIdError =  ''
      errorObj.workingOrganizationError =  ''
      errorObj.examDateError =  ''
      errorObj.examDateOptionError =  ''
      errorObj.tqTestTrackError =  ''
      errorObj.paymentModeError =  ''
      errorObj.referralCodeError =  ''
      errorObj.trackEligibilityError =  ''
      errorObj.tqTypeError = ''
      errorObj.timeSlotError = ''

      if(data.firstName === ''){
        errorObj.firstNameError = 'First Name is Mandatory'
        error = false
      }

      if(data.lastName === ''){
        errorObj.lastNameError = 'Last Name is Mandatory'
        error = false
      }

      if(data.email === ''){
        errorObj.emailError = 'Email is Mandatory'
        error = false
      }

      if(data.email !== null && data.email !== undefined && data.email !== ''){
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(data.email)){
          errorObj.emailFormatError ='Invalid Email Format'
          error = false
        }
      }

      if(data.countryId === ''){
        errorObj.countryIdError ='Country is mandatory'
        error = false
      }

      if(data.phone === ''){
        errorObj.phoneError = 'Mobile Number is Mandatory'
        error = false
      }

      if(((data.countryId === '1') || (data.countryId === 1)) && (!componentState.phoneDisabled)){
        if((!data.phone.startsWith('91')) || (data.phone.length < 12)){
          errorObj.phoneError = 'Please add country to your mobile number (no space or + needed).'
          error = false
        }
      }

      if(((data.countryId !== 1) || (data.countryId !== '1')) && (!data.phoneDisabled)){
        var phoneno = /^\d{8,14}$/;
        if(!data.phone.match(phoneno)){
          errorObj.phoneError ='Please add country to your mobile number (no space or + needed).'
          error = false
        }
      }

      if(data.dob === ''){
        errorObj.dobError = 'Date of Birth is Mandatory'
        error = false
      }

      if(data.teachingAssociationId === ''){
        errorObj.teachingAssociationIdError = 'Occupation is mandatory'
        error = false
      }

      if(data.teachingAssociationId && !(data.teachingAssociationName === 'No association with teaching' || data.teachingAssociationName === 'Tuition Teacher')){
        if(data.workingOrganization === '' || data.workingOrganization === null || data.workingOrganization === undefined){
          errorObj.workingOrganizationError ='Please enter the name of School/Organization/Institute'
          error = false
        }
      }

      // if(data.examDateOption === ''){
      //   errorObj.examDateOptionError = 'Please Choose Exam Option as either Immediate or Future.'
      //   error = false
      // }

      if(!data.examDate){
        errorObj.examDateOptionError ='Exam date is mandatory'
        error = false
      }

      if(data.paymentModeId === ''){
        errorObj.paymentModeError = 'Payment Mode is mandatory'
        error = false
      }

      if(data.tqTestTrackId === ''){
        errorObj.tqTestTrackError = 'Test Track is mandatory.'
        error = false
      }

      if((data.timeSlots.length > 0) && (!data.timeSlot)){
        errorObj.timeSlotError = 'Please choose a time slot'
        error = false
      }

      if(!error){
        saveState.saveDisabled = false
      }
      this.setState({
        formErrors:errorObj,
        errorMsg:'',
        saveState: saveState
      })
      return error
    }

    handleSubmit = (evt) => {
      evt.preventDefault()
      let data = Object.assign({}, this.state.data)
      let cert_part_id = this.state.cert_part_id
      if(this.validateForm()){
        let apiInput = {
         'cert_part_id': cert_part_id,
         'certification_participation': {
          'certification_type_id': '4',    
          },      
          'tq_certification': {         
            'working_organization': data.workingOrganization,
            'teaching_association_id': data.teachingAssociationId,
            'referral_code': data.referralCode,
            'global_type_id': data.tqTypeId,
            //'exam_date_option': data.examDateOption,
            'exam_date_option': 'Future',
            'selected_exam_date': data.examDate,
            'time_slot': data.timeSlot,
          },      
          'payment': {
            'payment_mode_id': data.paymentModeId,
            'currency': 'RS'
          },      
          'tq_certification_detail': {
            'tq_test_track_id': data.tqTestTrackId,
            'global_type_id': data.selectedAddonOption
          },
          'user':{
            'email': data.email,
            'phone': data.phone
          },
          'personal_info':{
            'first_name': data.firstName,
            'last_name': data.lastName,
            'dob': data.dob,
          },
          'address':{
            'country_id': data.countryId
          },
        }
      let url = `tq/certification/update/${this.state.data.tqRegId}`
      api.putValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        if(result.status === 'success'){
          let saveState = Object.assign({}, this.state.saveState)
          let errorMsg = this.state.errorMsg
          let componentState = Object.assign({}, this.state.componentState)
          saveState.saveDisabled = true
          errorMsg = result.message
          saveState.reDirLinkDisabled = false
          componentState.tqTrackDisabled = true
          this.setState({saveState: saveState, errorMsg: errorMsg, componentState: componentState})
        }
        else if (result.status === 'error'){
          let saveState = Object.assign({}, this.state.saveState)
          let errorMsg = this.state.errorMsg
          saveState.saveDisabled = false
          errorMsg = result.message
          this.setState({saveState: saveState, errorMsg: errorMsg})
        }
      })
      .catch((err) => {
          let saveState = Object.assign({}, this.state.saveState)
          saveState.saveDisabled = false
          let errorMsg = this.state.errorMsg
          this.setState({ errorMsg: err.stack, saveState: saveState })
      })
    }
  }
  
  render(){
    let mobileComponent

    if(this.state.data.phone !== '' || this.state.data.phone !== null || this.state.data.phone !== undefined){
      mobileComponent = (
        <GridCell span="6">
          <TextField fullwidth type="number" className= 'text_input' label = "Mobile No" autoComplete="off" name="phone" onChange={this.onInputChange} value={this.state.data.phone} disabled={this.state.componentState.phoneDisabled}></TextField>
        </GridCell>)
    }
    else{
       mobileComponent = (
        <GridCell span="6">
          <TextField fullwidth type="number" className= 'text_input' label = "Mobile No" autoComplete="off" name="phone" onChange={this.onInputChange} value={this.state.data.phone}></TextField>
        </GridCell>)
    }

    let TeachingOtherComponent
    if(this.state.data.teachingAssociationId && !(this.state.data.teachingAssociationName === 'No association with teaching' || this.state.data.teachingAssociationName === 'Tuition Teacher')){
      TeachingOtherComponent =(
        <PlacesAutoComplete
          value={this.state.data.workingOrganization}
            onChange={this.handleSchoolSelect}
            onSelect={this.handleSchoolChange}
            >
            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div>
              <TextField
                {...getInputProps({
                  placeholder: 'School/Organization/Institute',
                  className: 'location-search-input'
                })}
                name="school"
                
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map(suggestion => {
                  const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                              ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                              : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div {...getSuggestionItemProps(suggestion, { className, style })}>
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </PlacesAutoComplete>
      )
    }

    let examDateComponent
    if(this.state.data.examDateOption === 'Future'){
      examDateComponent = (<GridCell span="12">
        <TextField type="date" min={this.state.currentDate} className="datepicker-padding" label="Exam Date" autoComplete="off" name="examDate" onChange={this.onInputChange} value={this.state.data.examDate}/>
      </GridCell>)
    }

    let trackEligibilityComponent
    if(this.state.data.trackEligibility === 'not_eligible' && (this.state.data.tqTestTrackId != this.state.data.initialTqTestTrack)){
      trackEligibilityComponent = (<GridCell span= "12"><div style={{color: "red"}}>{this.state.data.trackDetailMessage}</div></GridCell>)
    }

    let regAmountComponent
    let discountTextComponent
    if(this.state.data.trackAmount > 0){
      let regFee = this.state.data.registrationFee
      let regFeeWithoutGST = regFee / 1.18
      let initialFee;
      if(this.state.data.selectedAddonOption === '') {
        initialFee = this.state.data.initialFee
      }
      else if (this.state.data.selectedAddonOption !== ''){
        initialFee = this.state.data.initialFeeWithAddOn
      }
      //regAmountComponent = <h4> Total registration fee Rs {this.state.data.registrationFee}{'/-'} (Rs.{parseFloat(regFeeWithoutGST).toFixed(2)} + 18% GST) approx ${this.state.data.registrationFeeInDollar} in US dollars.</h4>
      let percentDiscount = Math.floor(100-(regFeeWithoutGST/initialFee)*100)
      //discountTextComponent = <h5> (Post a {percentDiscount}% discount on the original fee of INR 1500 + GST) </h5>
      regAmountComponent = <p> Registration fee: <del>Rs {initialFee} + GST</del> <b>You Pay:</b> Rs {parseFloat(regFeeWithoutGST).toFixed(2)} + GST(Rs {this.state.data.registrationFee})/USD {parseFloat(this.state.data.registrationFeeInDollar).toFixed(2)}.<br/>{percentDiscount}% discount.</p>
    }
    else{
      regAmountComponent = <h4> Total Registraion Fee Rs. {this.state.data.registrationFee} /-</h4>  
    }

    let paymentModeComponent
    paymentModeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select 
            name="payment_mode"
            onChange={this.handlePaymentModeChange}
            value={this.state.data.paymentModeId}
            disabled={this.state.saveState.saveDisabled}
            className="mdc-select__native-control two-col-input"
          >
            <option value="" selected="">--Select Payment Mode--</option>
            {this.state.data.paymentModes.map(payment_mode => (
                <option key={payment_mode.id} value={payment_mode.id} data-name={payment_mode.name}>
                  {payment_mode.name} 
                </option>
            ))}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Payment Options</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>)

      let tqTypeComponent
        tqTypeComponent = (
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select
                name="type"
                onChange={this.handletqTypeChange}
                value={this.state.data.tqTypeId}
                className="mdc-select__native-control two-col-input">
                {this.state.data.tqType.map(function(tqTypes){
                    return(<option key={tqTypes.id} value={tqTypes.id} data-name={tqTypes.name}>
                      {tqTypes.name} 
                    </option>)
                })}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Type</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>)

        let successMessageComponent
          if(!this.state.saveState.reDirLinkDisabled){
            successMessageComponent = (
            <GridCell span ="6">
              Click <Link to="/portal/app/my_registrations">here</Link> to view your updated registration details.
            </GridCell>)
          }

              //add On Option component
        let isTrackSelectedAndAddonAvailable = false
        if((this.state.data.tqTestTrackId !== '' && this.state.data.isAddOnAvailableForParentTrack !== '') && !(this.state.saveState.saveDisabled)){
          isTrackSelectedAndAddonAvailable = true
        }

        let addonOptionComp = (
          <GridCell span="12">
            {this.state.data.addOnOptions.map(addonOption => (
              <label>

                <input type="checkbox" disabled={!isTrackSelectedAndAddonAvailable} name="selectedAddonOption" value={addonOption.id} checked={this.state.data.selectedAddonOption === addonOption.id } onChange={this.onAddonOptionChange} style={{verticalAlign: 'sub', zoom: '1.5', marginRight: '6px'}}/>
                
                Select this if you want to take up the 'Online Teaching' component in addition to this track (additional fee of INR 400 applicable). 
              
              </label>
            ))}
          </GridCell>
        )
      let listDateComponent
      listDateComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testDate"
                onChange={this.handleTQTestDateChange}
                value={this.state.data.examDate}
                className="mdc-select__native-control two-col-input"
                disabled={this.state.saveState.saveDisabled}
              >
                <option value="" selected="">--Select Exam Date--</option>
                {this.state.data.tqTestDates.map(testDate => (
                  <option key={testDate.test_date_id} value={testDate.examDate} data-name={testDate.exam_date}>
                    {testDate.exam_date} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Exam Date</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>
      ) 
    let timeSlotComponent
    if(this.state.data.timeSlots.length > 0){
      timeSlotComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testcenter"
                onChange={this.handleTQTimeSlotChange}
                value={this.state.data.timeSlot}
                disabled={this.state.saveState.saveDisabled}
                className="mdc-select__native-control two-col-input"
              >
                <option value="" selected="">--Select Time Slot--</option>
                {this.state.data.timeSlots.map(slot => (
                  <option key={slot.time_slot_id} value={slot.timeSlot} data-name={slot.time_slot}>
                    {slot.time_slot} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Time Slot</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>

      )
    }
  
    return(
      <Grid>
        <GridCell span="12">
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
              <Typography use="headline5">Update your Registration</Typography>
              <Grid className="opportunity-list-item">
                
                <GridCell span="6">
                  <TextField fullwidth className= 'text_input' label="First Name" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName} disabled ={this.state.componentState.firstNamedisabled}/>
                </GridCell>
                <GridCell span="6"></GridCell>

                <GridCell span="6">
                  <TextField fullwidth className= 'text_input' label="Last Name" autoComplete="off" name="lastName" onChange={this.onInputChange} value={this.state.data.lastName} disabled ={this.state.componentState.lastNamedisabled}/>
                </GridCell>
                <GridCell span="6"></GridCell>

                <GridCell span="6">
                  <TextField fullwidth className= 'text_input' label="Email" autoComplete="off" name="email" onChange={this.onInputChange} value={this.state.data.email}/>
                </GridCell>
                <GridCell span="6"></GridCell>
                
                {mobileComponent}
                <GridCell span="6"/>

                <GridCell span="6">
                  <TextField fullwidth type='date' max={this.state.currentDate} className= 'text_input' label="Date of Birth" autoComplete="off" name="dob" onChange={this.onInputChange} value={this.state.data.dob} disabled ={this.state.componentState.dobDisabled}/>
                </GridCell>
                <GridCell span="6"></GridCell>

                <GridCell span="6">
                  <div className="full-width">
                    <div className="mdc-select" role="listbox">
                    <select
                      name="country"
                      onChange = {this.handleCountriesChange}
                      value = {this.state.data.countryId}
                      className="mdc-select__native-control two-col-input"
                      disabled={this.state.componentState.countryDisabled}
                      >
                      <option value="" selected="">--Select Country--</option>
                      {this.state.data.countries.map(country => (
                        <option key={country.id} value={country.id} data-name={country.name}>
                          {country.name}
                        </option>
                      ))}
                      </select>
                      <label className="mdc-floating-label mdc-floating-label--float-above">Country</label>
                      <div className="mdc-line-ripple"></div>
                    </div>
                  </div>
                </GridCell>
                <GridCell span="6"/>

                <GridCell span ="6">
                 <div className="full-width">
                    <div className="mdc-select" role="listbox">
                      <select
                        name= "teachingAssociation"
                        onChange ={this.handleTeachingAssociationSelection}
                        value ={this.state.data.teachingAssociationId}
                        className="mdc-select__native-control two-col-input"
                        >
                        <option value="" selected="">--Select Occupation--</option>
                        {this.state.data.teachingAssociations.map(level => (
                          <option key={level.id} value={level.id} data-name={level.name}>
                            {level.name}
                          </option>
                        ))}
                      </select>
                      <label className="mdc-floating-label mdc-floating-label--float-above">Occupation</label>
                      <div className="mdc-line-ripple"></div>
                    </div>
                  </div>
                </GridCell>
                <GridCell span="6"/>

                <GridCell span="6">
                  {TeachingOtherComponent}
                </GridCell>
                <GridCell span="6"/>

                {/*<GridCell span="6">
                  Take the test on: 
                  <Radio name="examDateOption" value="Immediate" checked={this.state.data.examDateOption == 'Immediate'} onChange={this.onInputChange}>
                    Today
                  </Radio>
                  <Radio name="examDateOption" value="Future" checked={this.state.data.examDateOption == 'Future'} onChange={this.onInputChange}>
                    On a Later Date
                  </Radio>
                </GridCell>              
                <GridCell span="6"/> 
                {examDateComponent} */}

                <GridCell span="6">
                  <div className="full-width">
                      <div className="mdc-select" role="listbox">
                        <select 
                          name="testTrack"
                          onChange={this.handleTestTrackChange}
                          value={this.state.data.tqTestTrackId}
                          disabled ={this.state.componentState.tqTrackDisabled}
                          className="mdc-select__native-control two-col-input"
                        >
                          <option value="" selected="">--Select Test Track--</option>
                          {this.state.data.tqTestTracks.map(testTrack => (
                            <option key={testTrack.id} value={testTrack.id} data-name={testTrack.name} track-amount={testTrack.amount}>
                              {testTrack.name} 
                            </option>
                          ))}
                        </select>
                        <label className="mdc-floating-label mdc-floating-label--float-above">Test Track</label>
                        <div className="mdc-line-ripple"></div>
                      </div>
                    </div>
                </GridCell>
                <GridCell span ="6"/>

                {trackEligibilityComponent}
                {addonOptionComp}
                <GridCell span ="6">
                  {listDateComponent}
                  <GridCell span ="6"/>
                  <br />
                  {timeSlotComponent}
                </GridCell>
                <GridCell span ="6"/>

                <GridCell span="6">
                  <div>
                    <TextField className='text_input' label="Enter referral code (if any)" autoComplete="off" className="two-col-input" name="referralCode" onChange={this.onInputChange} value={this.state.data.referralCode} disabled={this.state.saveState.saveDisabled}/>
                    <Button onClick={this.handleDiscountApply} disabled={this.state.saveState.saveDisabled}>Apply</Button>
                    <br/>
                    <StatusMessage error_msg = {this.state.formErrors.referralCodeError}/>
                  </div>
                </GridCell>
                <GridCell span="6"/>

                <GridCell span="12">
                  {regAmountComponent}
                  {discountTextComponent}
                </GridCell>

                <GridCell span="6">
                  {paymentModeComponent}
                </GridCell>
                <GridCell span="6" />

                <GridCell span ="6">
                  <Button raised disabled={this.state.saveState.saveDisabled}>Update</Button>
                </GridCell>
                <GridCell span ="6"/>

                {successMessageComponent}
                <GridCell span ="6"/>

                <GridCell span="12">
                  <StatusMessage error_msg = {this.state.errorMsg}/>
                  <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
                  <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
                  <StatusMessage error_msg = {this.state.formErrors.emailError}/>
                  <StatusMessage error_msg = {this.state.formErrors.emailFormatError}/>
                  <StatusMessage error_msg = {this.state.formErrors.dobError}/>
                  <StatusMessage error_msg = {this.state.formErrors.phoneError}/>
                  <StatusMessage error_msg = {this.state.formErrors.teachingAssociationIdError}/>
                  <StatusMessage error_msg = {this.state.formErrors.workingOrganizationError}/>
                  <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
                  <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
                  <StatusMessage error_msg = {this.state.formErrors.tqTestTrackError}/>
                  <StatusMessage error_msg = {this.state.formErrors.examDateOptionError}/>
                  <StatusMessage error_msg = {this.state.formErrors.examDateError}/>
                  <StatusMessage error_msg = {this.state.formErrors.trackEligibilityError}/>
                  <StatusMessage error_msg = {this.state.formErrors.timeSlotError}/>
                </GridCell>
              </Grid>
            </Card>
          </form>
        </GridCell>
      </Grid>
      )
  }
} 

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TQRegistrationUpdate);


// WEBPACK FOOTER //
// ./src/views/TQRegistrationUpdate.jsx